/**
 * 场馆模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取场馆列表
export const deptList = (params) => {
  return req.get('/system/dept/list', params);
}

// 新增场馆
export const deptAdd = (params) => {
  return req.post('/system/dept', params);
}

// 获取场馆详细信息
export const deptInfo = (deptId) => {
  return req.get(`/system/dept/${deptId}`);
}

// 获取场馆营业时间
export const getDeptBusinessTime = (params) => {
  return req.get(`/deptPrescriptionEffectivenessConfig/queryDeptWorkTimeConfigs`, params);
}

// 修改场馆信息
export const deptEdit = (params) => {
  return req.put('/system/dept', params);
}

// 删除场馆信息
export const deptDelete = (deptId) => {
  return req.delete(`/system/dept/${deptId}`);
}

// 获取药事中心
export const getDrugCenterList = (params) => {
  return req.get(`/system/dept/drugCenter/list`, params);
}

// 获取所有可用医馆
export const getEffectiveDeptList = (params) => {
  return req.get(`/deptPrescriptionEffectivenessConfig/allDept`, params);
}

// 获取自提/发货时间配置
export const getDeliveryTimeConfigList = (params) => {
  return req.get(`/deptPrescriptionEffectivenessConfig/queryDeptPrescriptionEffectivenessConfig`, params);
}

// 导入分馆配送时间配置
export const importDeptDeliveryTimeConfig = (params) => {
  return req.uploadPost('/deptPrescriptionEffectivenessConfig/importDeptPrescriptionEffectivenessConfig', params, '/api', { 'Content-Type': 'multipart/form-data' });
}

// 导出分馆配送时间配置
export const exportDeptDeliveryTimeConfig = (params, customConfig) => {
  return req.downloadGet('/deptPrescriptionEffectivenessConfig/exportDeptPrescriptionEffectivenessConfig', params, customConfig, 'application/vnd.ms-excel');
}

// 导入药事服务中心配送时间配置
export const importPharmacyDeliveryTimeConfig = (params) => {
  return req.uploadPost('/deptPrescriptionEffectivenessConfig/importDeptPrescriptionEffectivenessConfigYs', params, '/api', { 'Content-Type': 'multipart/form-data' });
}


// 导出药事服务中心配送时间配置
export const exportPharmacyDeliveryTimeConfig = (params, customConfig) => {
  return req.downloadGet('/deptPrescriptionEffectivenessConfig/exportDeptPrescriptionEffectivenessConfigYs', params, customConfig, 'application/vnd.ms-excel');
}
